import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RefundPaymentDialogData {
  reservationId: string;
  customerName: string;
  paidAmount: number;
  currencySymbol: string;
  paymentDate: string;
}

export interface RefundPaymentDialogResult {
  confirmed: boolean;
}

@Component({
  selector: 'app-refund-payment-dialog',
  templateUrl: './refund-payment-dialog.component.html',
  styleUrls: ['./refund-payment-dialog.component.scss']
})
export class RefundPaymentDialogComponent {
  isProcessing = false;
  
  constructor(
    public dialogRef: MatDialogRef<RefundPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RefundPaymentDialogData
  ) {}

  get refundAmount(): string {
    const symbol = this.data.currencySymbol || '\u20ac';
    const amount = this.data.paidAmount || 0;
    return `${symbol}${amount.toFixed(2)}`;
  }

  get processingMessage(): string {
    return 'refund_dialog.processing';
  }

  onCancel(): void {
    if (this.isProcessing) return;
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    if (this.isProcessing) return;
    this.isProcessing = true;
    this.dialogRef.close({ confirmed: true });
  }
}
